import { GlobalLoader, Modal, SelectInput } from '@reactiveonline/reactive_admin_shared-packages'
import React, { useState } from 'react'

const flavourOptions = [
  { 
    title: Support.translations.module_names.shop,
    value: 'shop'
  },
  { 
    title: Support.translations.module_names.travel,
    value: 'travel'
  },
  { 
    title: Support.translations.module_names.ordering,
    value: 'ordering'
  },
  { 
    title: Support.translations.module_names.appointment,
    value: 'appointment'
  }
]

export default function MoveAccount({ account, moveAccountPath, flashMessageRef, setLoading, loading }) {
  const relatedFlavourIndex = flavourOptions.findIndex(el => el.value === account.flavour.toLowerCase())

  const remainingFlavourOptions = [
    ...flavourOptions.slice(0, relatedFlavourIndex),
    ...flavourOptions.slice(relatedFlavourIndex + 1)
  ]

  const [newFlavour, setNewFlavour] = useState(remainingFlavourOptions[0])
  const [showMoveAccountModal, setShowMoveAccountModal] = useState(false)

  const produceConfirmationText = _ => `Are you sure you want to move this account from ${ Support.translations.module_names[account.flavour.toLowerCase()] } to ${ newFlavour.title }?`

  const handleMoveAccount = _ => {
    const fd = new FormData()
    
    fd.append('flavour', newFlavour.value)

    setLoading(true)

    Rails.ajax({
      type: 'POST',
      url: moveAccountPath,
      dataType: 'json',
      data: fd,
      success: _res => {
        setLoading(true)
        window.location.reload()
      },
      error: res => {
        setLoading(false)
        flashMessageRef.current.show(res.error, 'error')
      }
    })
  }

  return (
    <>
      <div 
        className="btn flex-box items-center content-center"
        style={{ cursor: 'pointer' }}
        onClick={ _ => setShowMoveAccountModal(true) }
      >
        <i className='fa-light fa-swap m-r-10' />
        <span>
          Move
        </span>
      </div>

      { showMoveAccountModal &&
        <Modal
          visible
          closeModal={ _ => setShowMoveAccountModal(false) }
          mode='large'
          showConfirmation
          confirmationText={ produceConfirmationText() }
          action={ handleMoveAccount }
          actionText={ ReactiveCore.translations.confirm }
        >
          <div className='flex-box flex-column content-center' style={{ width: '100%' }}>
            <div className='title bold'>
              { 'Move account' }
            </div>
            <div>
              { `This customer is currently placed in ${ Support.translations.module_names[account.flavour.toLowerCase()] } with account uid ${ account.account_uid }.` }
            </div>

            <SelectInput
              label={ 'Choose where to move' }
              options={ remainingFlavourOptions }
              currentOption={ newFlavour.value }
              setCurrentOption={ option => setNewFlavour(option) }
            />
          </div>

          { loading && <GlobalLoader fullPage /> }
        </Modal>
      }
    </>
  )
}